export default __webpack_public_path__ + "images/AK.bee356c.png";